export const QUERY_KEY = 'commonCompanyProfiles';

export const PAGE_ROUTE = '/admin/common-company-profiles';

export const TABLE_HEADERS = ['Name', 'Cap IQ ID', 'Sacra Domain', 'Zanbato ID', 'Actions'];
